import './Accessibility.scss';
import $ from 'jquery';


function resizeText(multiplier) {
    if (document.body.style.fontSize === "") {
        document.body.style.fontSize = "1.0em";
    }
    document.body.style.fontSize = parseFloat(document.body.style.fontSize) + (multiplier * 0.2) + "em";
}


(function (window) {
    "use strict";
    window.accessibilityManager = {
        menu: null,
        cookieName: "accessibilityCookie",
        cookieFontAttribute: "fontMultiplier",
        fontMultiplier: 1,
        init: function () {
            accessibilityManager.menu = $("#accesabilityMenu");
            accessibilityManager.menu.find(".textMinus").on("click", accessibilityManager.textMinus_Click);
            accessibilityManager.menu.find(".textPlus").on("click", accessibilityManager.textPlus_Click);
            accessibilityManager.menu.find("ul li a[data-action]").on("click", accessibilityManager.action_Click);
            accessibilityManager.menu.find("a.openAccesabilityMenu")
                .on("click", accessibilityManager.openAccesabilityMenu_Click);

            // #region set values by cookie 
            var settings = accessibilityManager.getCookie();
            if (settings !== null) {
                accessibilityManager.menu.find("ul li a[data-action]").each(function () {
                    var action = $(this).data("action");
                    if (settings[action] === true || settings[action] === "true") {
                        $(this).click();
                    }
                });
                var multiplier = settings[accessibilityManager.cookieFontAttribute];
                if (multiplier !== 1) {
                    accessibilityManager.resizeText(multiplier);
                }
            }
            // #endregion
        },
        openAccesabilityMenu_Click: function () {
            $("#accesabilityMenu").toggleClass("open");

            if ($(window).width() <= 650) {
                if ($('#accesabilityMenu').hasClass('open')) {
                    $('#accesabilityMenu.open').attr('style', 'width: 100% !important');
                }
                else {
                    setTimeout(function () {
                        $('#accesabilityMenu').attr('style', 'width: 84px !important');
                    }, 500);
                }
            }
        },
        action_Click: function (e) {
            var action = $(this).data("action");
            var className = "";
            var active = $(this).data("active") === "true" || $(this).data("active") === true;
            switch (action) {
                case "ContrastBright":
                    className = "accessible_contrast_white";
                    break;
                case "ContrastDark":
                    className = "accessible_contrast";
                    break;
                case "NoAnimations":
                    className = "accessible_animation";
                    break;
                case "ColorBlind":
                    className = "accessible_colorblind";
                    break;
                case "reset":
                    accessibilityManager.reset();
                    return;
                default:
            }
            if (active) {
                $("body").removeClass(className);
                $(this).data("active", false);
                $(this).parents("li").eq(0).removeClass("active");
            } else {
                $("body").addClass(className);
                $(this).data("active", true);
                $(this).parents("li").eq(0).addClass("active");
            }
            accessibilityManager.setCookie();
        },
        textMinus_Click: function (e) {
            accessibilityManager.resizeText(-1);
            accessibilityManager.setCookie();
        },
        textPlus_Click: function (e) {
            accessibilityManager.resizeText(1);
            accessibilityManager.setCookie();
        },
        resizeText: function (multiplier) {
            accessibilityManager.fontMultiplier += multiplier;
            $("*").filter(":not(.no_resize_font,body)").filter(":not(.no_resize_font *)").each(function () {
                var $this = $(this).eq(0);
                if ($this.css("fontSize") === "") {
                    $this.css("fontSize", "1.0em");
                }
                var val = parseFloat($this.css("fontSize")) + (multiplier * 1) + "px";
                $this.css("fontSize", val);
                $this.css("line-height", val);
            });
        },
        setCookie: function () {
            var valueObject = {};

            accessibilityManager.menu.find("ul li a").each(function () {
                var $this = $(this);
                valueObject[$this.data("action")] = $this.data("active");
            });
            valueObject[accessibilityManager.cookieFontAttribute] = accessibilityManager.fontMultiplier;
            accessibilityManager._setCookieByObject(valueObject, 1);
        },
        getCookie: function () {
            var name = accessibilityManager.cookieName;
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            var resString = "";
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) resString = c.substring(nameEQ.length, c.length);
            }
            if (resString !== "") {
                return JSON.parse(resString);
            }
            return null;
        },
        _setCookieByObject: function (valueObject, days) {
            var value = "";
            var expires = "";
            value = JSON.stringify(valueObject);
            if (days >= 1) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
            document.cookie = accessibilityManager.cookieName + "=" + value + expires + "; path=/";
        },
        reset: function () {
            accessibilityManager._setCookieByObject({}, -1);
            document.location = document.location;
        }
    };
    $(document).ready(accessibilityManager.init);
})(window);


// WEBPACK FOOTER //
// ./Src/Shared/Accessibility/Accessibility.js